<template>
  <div v-editable="blok">
    <div class="page-mx module-pt module-pb">
      <ElementTexts
        v-if="blok.texts?.length"
        :bloks="blok.texts"
        textPosition="center"
        class="clamp-mb-8-12" />
      <div class="flex flex-col items-center clamp-gap-8-12 w-full">
        <div
          v-if="state === 'LOADING' || state === 'RESULTS'"
          class="grid grid-cols-12 clamp-gap-y-5-5 mpl:clamp-gap-x-5-5 bg-white card-rounded card-p clamp-min-h-90-90 w-full">
          <template v-for="story in loadedArticles">
            <ElementMediaGalleryCard
              :media="media"
              v-for="media in story.content.media"
              class="col-span-12 mpl:col-span-6 tp:col-span-3" />
          </template>
        </div>
        <AButton v-if="showLoadMoreButton" @click="loadMore" text="Load more" />
        <ElementErrorNoResults
          v-if="state === 'ERROR' || state === 'NO_RESULTS'"
          :blok="blok.errorNoResults[0]" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useArticles from "@/composables/useArticles";
import { ISbStoryData } from "@storyblok/vue";
import {
  ModuleArticlesMediaGalleryStoryblok,
  TemplateArticleStoryblok,
} from "@/types";

interface Props {
  blok: ModuleArticlesMediaGalleryStoryblok;
}
const props = defineProps<Props>();

const { totalItems, fetchArticles, state } = useArticles();

const postsPerPage = 4;
const currentPage = ref(1);
const loadedArticles = ref<ISbStoryData<TemplateArticleStoryblok>[]>([]);

const loadMore = async () => {
  currentPage.value++;
  const newArticles = await fetchArticles({
    postsPerPage: postsPerPage,
    currentPage: currentPage.value,
    searchTerm: "",
    filter: { media: { is: "not_empty" } },
  });

  // Append new articles to loadedArticles
  loadedArticles.value = [...loadedArticles.value, ...newArticles];
};

const updatePage = async () => {
  // Fetch articles and assign them to loadedArticles
  loadedArticles.value = await fetchArticles({
    postsPerPage: postsPerPage,
    currentPage: currentPage.value,
    searchTerm: "",
    filter: { media: { is: "not_empty" } },
  });
};

const showLoadMoreButton = computed(() => {
  return loadedArticles.value.length < totalItems.value;
});

onMounted(() => {
  updatePage();
});
</script>

<style scoped></style>
